export default "__VITE_ASSET__CER6r6zH__"